"use client";

import React from "react";

// Forward the ref so <Input ref={...} /> works without errors
export const Input = React.forwardRef((props, ref) => (
  <input ref={ref} {...props} />
));

Input.displayName = "Input";

export default Input;
